import React from 'react';
import { observer } from "mobx-react";
import { InfoBadgeNs } from 'ReactApp/Types/InfoBadgeNs';
import IconV1 from 'ReactApp/Components/IconV1/IconV1';

type BadgeV1Props = InfoBadgeNs.InfoBadge & {}

const BadgeV1 = observer((props: BadgeV1Props) => {

    let classes = ['badge-v1'];
    if (Array.isArray(props.classes)) {
        classes.push(...props.classes);
    }

    return (
        <div className={classes.join(' ')}>
            <div className="badge-v1__wrap">
                {props.iconProps !== undefined && (
                    <div className="badge-v1__icon">
                        <IconV1 {...props.iconProps} />
                    </div>
                )}
                {props.label !== undefined && (
                    <div className="badge-v1__label">{
                        (typeof props.label === 'function')
                            ? props.label()
                            : props.label
                    }</div>
                )}
            </div>
        </div>
    );

})

export default BadgeV1;